import { SignIn } from 'components/SignIn/SignIn'

export const UnauthenticatedHome = () => {
  return (
    <>
      Please <SignIn /> to start
    </>
  )
}
